import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import siteThumbnail from './assets/img.png'

const favicon = document.querySelector("link[rel='icon']")
if (favicon) {
  favicon.href = siteThumbnail
  favicon.type = 'image/png'
}

const ogImage = document.querySelector("meta[property='og:image']")
if (ogImage) {
  ogImage.setAttribute('content', siteThumbnail)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
